/**
 * Restaure certaines clés depuis l'objet original
 * vers l'objet transformé (ex: après camelcaseKeys)
 *
 * @param {any} original - Donnée originale (snake_case)
 * @param {any} transformed - Donnée transformée (camelCase)
 * @param {string[]} keysToRestore - Clés à restaurer (ex: ["metadata"])
 */
export const restoreKeys = (original, transformed, keysToRestore = []) => {
  if (!original || !transformed) return;

  // ✅ Gestion des tableaux
  if (Array.isArray(original)) {
    original.forEach((item, index) => {
      restoreKeys(item, transformed[index], keysToRestore);
    });
    return;
  }

  // ✅ On ne traite que les objets
  if (typeof original !== "object") return;

  Object.keys(original).forEach((key) => {
    const value = original[key];

    // 🔹 Si la clé doit être restaurée
    if (keysToRestore.includes(key)) {
      transformed[key] = value;
      return;
    }

    if (typeof value === "object" && value !== null) {
      // 🔹 Conversion snake_case → camelCase
      const camelKey = key.replace(/_([a-z])/g, (_, letter) =>
        letter.toUpperCase()
      );

      if (transformed[camelKey]) {
        restoreKeys(value, transformed[camelKey], keysToRestore);
      }
    }
  });
};
